import LoginModal from "@/components/loginModal";
import { createContext, useContext, useState } from "react";

interface LoginModalContextType {
  isOpen: boolean;
  open: (onSuccess: () => void) => void;
  close: () => void;
  onSuccess: () => void;
}

const LoginModalContext = createContext<LoginModalContextType | undefined>(
  undefined
);

export const LoginModalProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [onSuccess, setOnSuccess] = useState<() => void>(() => () => {});

  const open = (onSuccess: () => void) => {
    setIsOpen(true);
    setOnSuccess(() => () => {
      onSuccess();
      close();
    });
  };

  const close = () => {
    setIsOpen(false);
  };

  return (
    <LoginModalContext.Provider value={{ isOpen, open, close, onSuccess }}>
      {children}
      <LoginModal open={isOpen} onClose={close} onSuccess={onSuccess} />
    </LoginModalContext.Provider>
  );
};

export const useLoginModal = () => {
  const context = useContext(LoginModalContext);
  if (context === undefined) {
    throw new Error("useLoginModal must be used within a LoginModalProvider");
  }
  return context;
};
